import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import moment from 'moment';

class FlightReportOfflineLegEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      status_str: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null,
      modal: false,
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      duties_select: [],
      staffs_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      style: {},
      errors: {},
    };

    this.edit = this.edit.bind(this);
    this.editMobile = this.editMobile.bind(this);
    this.diffFlight = this.diffFlight.bind(this);
    this.diffTotalTime = this.diffTotalTime.bind(this);
    this.delayFlight = this.delayFlight.bind(this);
    this.delayTotalTime = this.delayTotalTime.bind(this);
    this.calcTimeFromMs = this.calcTimeFromMs.bind(this);
    this.autoFillTime = this.autoFillTime.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }
  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;
    if (name === 'takeoff_time') {
      this.diffFlight(now, this.state.landing_time, change);
      this.delayFlight(now, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, now, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, now, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(now, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentDidMount() {

    let index_key = this.props.index_key; if (index_key === null) index_key = '';
    let takeoff_scheduled = this.props.flight_report_leg_edit.takeoff_scheduled_str; if (takeoff_scheduled === null) takeoff_scheduled = '';
    let total_time_preview = this.props.flight_report_leg_edit.total_time_preview; if (total_time_preview === null) total_time_preview = '';
    let engine_start_time = this.props.flight_report_leg_edit.engine_start_time_str; if (engine_start_time === null) engine_start_time = '';
    let takeoff_time = this.props.flight_report_leg_edit.takeoff_time_str; if (takeoff_time === null) takeoff_time = '';
    let landing_time = this.props.flight_report_leg_edit.landing_time_str; if (landing_time === null) landing_time = '';
    let engine_shutoff_time = this.props.flight_report_leg_edit.engine_shutoff_time_str; if (engine_shutoff_time === null) engine_shutoff_time = '';
    let takeoff_land_time = this.props.flight_report_leg_edit.takeoff_land_time; if (takeoff_land_time === null) takeoff_land_time = '';
    let total_time = this.props.flight_report_leg_edit.total_time; if (total_time === null) total_time = '';
    let navigation_time = this.props.flight_report_leg_edit.navigation_time; if (navigation_time === null) navigation_time = '';
    let ifr_time = this.props.flight_report_leg_edit.ifr_time; if (ifr_time === null) ifr_time = '';
    let night_time = this.props.flight_report_leg_edit.night_time; if (night_time === null) night_time = '';

    var flight_report_legs_lists = JSON.parse(localStorage.getItem("flight_report_legs_lists"));

      this.setState({
        index_key: this.props.index_key,
        flight_report_number: this.props.flight_report_leg_edit.flight_report_number,
        flight_report_leg_edit_staffs: this.props.flight_report_leg_edit_staffs,
        locations_select: flight_report_legs_lists.locations_select,
        ptbr_codes_select: flight_report_legs_lists.ptbr_codes_select,
        ptbr_operations_select: this.props.ptbr_operations_select,
        ptbr_external_loads_select: this.props.ptbr_external_loads_select,
        staffs_select: this.props.staffs_select,
        duties_select: this.props.duties_select,
        style: this.props.style,
        date: this.props.date,
        id: this.props.flight_report_leg_edit.id,
        errors: this.props.flight_report_leg_edit.errors,
        flight_report_id: this.props.flight_report_leg_edit.flight_report_id,
        status: this.props.flight_report_leg_edit.status,
        status_str: this.props.flight_report_leg_edit.status_str,
        departure_location_id: this.props.flight_report_leg_edit.departure_location_id,
        arrival_location_id: this.props.flight_report_leg_edit.arrival_location_id,
        takeoff_scheduled: takeoff_scheduled,
        total_time_preview: total_time_preview,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: takeoff_land_time,
        total_time: total_time,
        navigation_time: navigation_time,
        ifr_time: ifr_time,
        night_time: night_time,
        day_landings: this.props.flight_report_leg_edit.day_landings,
        night_landings: this.props.flight_report_leg_edit.night_landings,
        starts: this.props.flight_report_leg_edit.starts,
        pax: this.props.flight_report_leg_edit.pax,
        payload: this.props.flight_report_leg_edit.payload,
        external_load_long_line: this.props.flight_report_leg_edit.external_load_long_line,
        external_load_short_line: this.props.flight_report_leg_edit.external_load_short_line,
        fuel_start: this.props.flight_report_leg_edit.fuel_start,
        fuel_end: this.props.flight_report_leg_edit.fuel_end,
        ptbr_code_id: this.props.flight_report_leg_edit.ptbr_code_id,
        ptbr_operation_id: this.props.flight_report_leg_edit.ptbr_operation_id,
        ptbr_external_load_id: this.props.flight_report_leg_edit.ptbr_external_load_id,
        delay_departure: this.props.flight_report_leg_edit.delay_departure,
        delay_time: this.props.flight_report_leg_edit.delay_time,
        leg_number: this.props.flight_report_leg_edit.leg_number,
        start_parameter_total: this.props.start_parameter_total,
        xml: this.props.xml,
        external_load: this.props.external_load,
      });

  }


    diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        let diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }

    diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      let start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      let finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if(start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = moment(start, "DD/MM/YYYY HH:mm:ss");
        finish = moment(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));

        let diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }

    delayFlight(takeoff_time, takeoff_scheduled, change) {
      if(takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = moment(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        let diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g,"T"));
        let diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }

    delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if(takeoff_land_time) {
        takeoff_land_time = moment().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = moment().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g,"T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g,"T"));
        let diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }

    calcTimeFromMs(diffTime) {
      diffTime = diffTime/1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) { secs = '0' + secs; }
      if (mins < 10) { mins = '0' + mins; }
      if (hrs < 10) { hrs = '0' + hrs; }
      return hrs + ':' + mins + ':' + secs ;
    }

  // Fetch salvando a edição
  editMobile(event) {
    event.preventDefault();
    this.edit();
  }

  // Fetch salvando a edição
  // Fetch salvando a adição
  edit() {
    this.props.handleAlert('', '', 'open');

    let takeoff_scheduled = null;
    let engine_start_time = null;
    let takeoff_time = null;
    let landing_time = null;
    let engine_shutoff_time = null;

    if (this.state.takeoff_scheduled) takeoff_scheduled = this.state.date + ' ' + this.state.takeoff_scheduled;
    if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
    if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
    if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
    if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

    if (takeoff_scheduled) takeoff_scheduled = moment(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");
    if (engine_start_time) engine_start_time = moment(engine_start_time, "DD/MM/YYYY HH:mm:ss");
    if (takeoff_time) takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
    if (landing_time) landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");
    if (engine_shutoff_time) engine_shutoff_time = moment(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

    if (takeoff_scheduled) {
        let diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
            if (engine_start_time) engine_start_time.add(1, 'd');
            if (takeoff_time) takeoff_time.add(1, 'd');
            if (landing_time) landing_time.add(1, 'd');
            if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
    }


    if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
    }

    if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
    }

    if (engine_start_time) engine_start_time = engine_start_time.format("HH:mm");
    if (takeoff_time) takeoff_time = takeoff_time.format("HH:mm");
    if (landing_time) landing_time = landing_time.format("HH:mm");
    if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("HH:mm");
    if (takeoff_scheduled) takeoff_scheduled = takeoff_scheduled.format("HH:mm");

    var storage = localStorage.getItem("new_flight_report_legs_full");

    storage = JSON.parse(storage);

    storage[this.state.index_key] =
    {
      flight_report_id: this.state.flight_report_id,
      departure_location_id: this.state.departure_location_id,
      arrival_location_id: this.state.arrival_location_id,
      takeoff_scheduled: takeoff_scheduled,
      total_time_preview: this.state.total_time_preview,
      engine_start_time: engine_start_time,
      takeoff_time: takeoff_time,
      landing_time: landing_time,
      engine_shutoff_time: engine_shutoff_time,
      takeoff_land_time: this.state.takeoff_land_time,
      takeoff_scheduled_str: takeoff_scheduled,
      engine_start_time_str: engine_start_time,
      takeoff_time_str: takeoff_time,
      landing_time_str: landing_time,
      engine_shutoff_time_str: engine_shutoff_time,
      total_time: this.state.total_time,
      navigation_time: this.state.navigation_time,
      ifr_time: this.state.ifr_time,
      night_time: this.state.night_time,
      day_landings: this.state.day_landings,
      night_landings: this.state.night_landings,
      starts: this.state.starts,
      pax: this.state.pax,
      payload: this.state.payload,
      external_load_long_line: this.state.external_load_long_line,
      external_load_short_line: this.state.external_load_short_line,
      fuel_start: this.state.fuel_start,
      fuel_end: this.state.fuel_end,
      delay_time: this.state.delay_time,
      delay_departure: this.state.delay_departure,
      ptbr_code_id: this.state.ptbr_code_id,
      ptbr_operation_id: this.state.ptbr_operation_id,
      ptbr_external_load_id: this.state.ptbr_external_load_id,
      errors: this.state.errors,
      status: this.state.status,
      status_str: this.state.status_str,
    };

    localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));
        
    this.props.handleAlert('', '', 'closed');

  }


  render() {
    var self = this;
    return (
  <tr>
    <th className="text-center">
      <button type="button" className="btn btn-primary" onClick={() => {self.edit()}}><i className="fa fa-fw fa-save"></i></button>
    </th>
    {((this.state.flight_report_number !== 'undefined' && this.state.flight_report_number !== undefined) ?
        <td style={{width: '200px'}}>
            <input type="text" value={this.state.flight_report_number} name="flight_report_number " className="form-control" onChange={this.handleChange.bind(this, 'flight_report_number')} placeholder=""  />
        </td>
        :
        <td style={{width: '200px'}}>{this.state.flight_report_id}</td>
    )}
    <td style={{width: '200px'}}>{this.state.leg_number}</td>
    <td>
      <RequestApi ref={'request_api'} />
      <Select
        className="form-field-name"
        style={this.state.style.select_places}
        name="departure_location_id"
        value={this.state.departure_location_id}
        searchable={true}
        placeholder={''}
        onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
        options={this.state.locations_select}
        
      />
    </td>
    <td>
      <Select
        className="form-field-name"
        style={this.state.style.select_places}
        name="arrival_location_id"
        value={this.state.arrival_location_id}
        searchable={true}
        placeholder={''}
        onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
        options={this.state.locations_select}

      />
    </td>
    <td>
        <InputMask style={this.state.style.input_hour} value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder="" />
    </td>
    <td>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('engine_start_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder="" />
    </td>
    <td>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('takeoff_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder="" />
    </td>
    <td>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('landing_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />
    </td>
    <td>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => {self.autoFillTime('engine_shutoff_time')}}><i className="fa fa-fw fa-clock-o"></i></button>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
    </td>
    {this.state.external_load == 1 ? 
      <td>
        <br/>
        <Toggle
          checked={this.state.external_load_long_line}
          aria-label='No label tag'
          name="external_load_long_line"
          onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
      </td>

    : ''
    }
    {this.state.external_load == 1 ? 
      <td>
        <br/>
        <Toggle
          checked={this.state.external_load_short_line}
          aria-label='No label tag'
          name="external_load_short_line"
          onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
      </td>
    : ''
    }
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
    </td>
    {this.state.xml == 1 ? 
      <td>
        <Select
          className="form-field-name"
          name="ptbr_code_id"
          value={this.state.ptbr_code_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
          options={this.state.ptbr_codes_select}
          style={this.state.style.select_operation}
        />
      </td>
    : ''
    }
    <td style={{width: '200px'}}>{this.state.status_str}</td>
    <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
        <button type="button" className="btn btn-primary" onClick={() => {self.edit()}}><i className="fa fa-fw fa-save"></i></button>
        <button type="button" className="btn btn-danger" onClick={() => {self.props.delete(self.state.index_key)}}><i className="fa fa-fw fa-trash"></i></button>
        {this.state.status == 'error' ? 
          <button type="button" className="btn btn-warning" onClick={() => {self.props.openModal(self.state.errors)}}><i className="fa fa-file-pdf-o"></i></button>

        : ''
        }
    </td>

  </tr>
    );
  }
}

export default FlightReportOfflineLegEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportOfflineLegEditTab.js